import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; 
import "./Privacy.css"; // Ensure you have the correct CSS file

const Privacy = () => {
  const [selectedTopic, setSelectedTopic] = useState("");
  const location = useLocation();

  // const handleButtonClick = (topic) => {
  // If the same button is clicked again, toggle it off
  //   setSelectedTopic(selectedTopic === topic ? "" : topic);
  // };

  useEffect(() => {
  
    const searchParams = new URLSearchParams(location.search);
    const policy = searchParams.get("policy");
    if (policy) {
      setSelectedTopic(policy);
    }
  }, [location.search]);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-5 mt-5" id="cardh2">Privacy & Terms</h2>
      
      {/* 3 Buttons in a Row */}
      <div className="row">
        <div className="col-md-4 mb-3 order-3 order-md-1" >
           
              <button 
        className={`btn w-100 ${selectedTopic === "privacy" ? "btn-white" : "text-white bg-black"}`} 
        onClick={() => setSelectedTopic(selectedTopic === "privacy" ? "" : "privacy")}
        id="privacybtn"
      >
        Privacy Policy
      </button>
          
        </div>
        <div className="col-md-4 mb-3 order-2 order-md-2">
        <button 
          className={`btn w-100 ${selectedTopic === "terms" ? "btn-white" : "text-white bg-black"}`} 
          onClick={() => setSelectedTopic(selectedTopic === "terms" ? "" : "terms")}
          id="privacybtn"
        >
          Terms & Conditions
        </button>
        </div>
        <div className="col-md-4 mb-3 order-1 order-md-3">
        <button 
          className={`btn w-100 ${selectedTopic === "refund" ? "btn-white" : "text-white bg-black"}`} 
          onClick={() => setSelectedTopic(selectedTopic === "refund" ? "" : "refund")}
          id="privacybtn"
        >
          Refund Policy
        </button>
        </div>
      </div>

      {/* Display Content Based on Selected Button */}
      {selectedTopic && (
        <div className="privacy-content mt-4 p-3">
          {selectedTopic === "privacy" && (
            <div>
              <h3>Introduction</h3>
              <p>
              Your privacy is important to us. This privacy policy document outlines the types of personal information that is received and collected by us and how it is used.
              </p>
              <h3>Information We Collect</h3>
              <p>
              We collect various types of information in order to provide you with a better user experience. The types of information include:
              </p>
              <ul>
                <li>Personal Information (e.g., name, email address, phone number)</li>
                <li>Usage Data (e.g., IP address, browser type, device information)</li>
                <li>Cookies and Tracking Data</li>
              </ul>
              <h3>How We Use Your Information</h3>
              <p>The information we collect is used for purposes such as:</p>
              <ul>
                <li>Improving our website and services</li>
                <li>Sending promotional emails or newsletters</li>
                <li>Providing customer support</li>
                <li>Analyzing website usage and trends</li>
              </ul>
              <h3>Third-Party Services</h3>
              <p>We may use third-party services such as analytics tools and advertising networks to enhance the website's functionality. These third parties may have access to your information but are obligated to keep it confidential.</p>
              <h3>Cookies</h3>
              <p>Our website uses cookies to improve your experience. Cookies are small data files that are stored on your device. You can control cookie preferences through your browser settings.</p>
              <h3>Data Security</h3>
              <p>We take reasonable precautions to protect your personal data from unauthorized access, alteration, or destruction. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>
              <h3>Your Rights</h3>
              <p>You have the right to access, correct, or delete your personal data. If you wish to exercise these rights, please contact us via the provided contact information.</p>
              <h3>Changes to This Privacy Policy</h3>
              <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the date of the last revision will be indicated at the bottom of the policy.</p>
            </div>
          )}

          {selectedTopic === "terms" && (
            <div>
              <h3 className="text-center">Terms & Conditions</h3>
              <h3>1. Introduction</h3>
              <p>Welcome to fusionspherellp.com These terms and conditions outline the rules and regulations for the use of our website and services.</p>
              <h3>2. Acceptance of Terms</h3>
              <p>
              By accessing this website, you agree to be bound by these terms and conditions. If you do not agree, you are prohibited from using or accessing this website.
              </p>
              <h3>3. Use of Our Services</h3>
              <p>You may use our services only for lawful purposes and in accordance with these Terms. You agree not to use our services:</p>
              <p>For any unlawful purpose</p>
                <p>To harass or harm others</p>
                <p>To transmit viruses or other harmful computer code</p>

                <h3>4. User Responsibilities</h3>
                <p>As a user, you are responsible for maintaining the confidentiality of your account and password. You agree to notify us immediately of any unauthorized use of your account.</p>
                
                <h3>5. Content Ownership</h3>
                <p>The content, including text, images, and software, available on this website is the property of [Your Website Name] and is protected by copyright law. Unauthorized use or reproduction is prohibited.</p>

                <h3>6. Limitation of Liability</h3>
                <p>In no event shall [Your Website Name] or its affiliates be liable for any damages arising out of the use or inability to use our website or services.</p>

                <h3>7. Privacy Policy</h3>
                <p>Your use of this website is also governed by our Privacy Policy.</p>

                <h3>8. Changes to Terms</h3>
                <p>We may update these terms and conditions from time to time. Any changes will be posted on this page, and the date at the top will reflect the last update.</p>

                <h3>9. Governing Law</h3>
                <p>These terms will be governed by and construed in accordance with the laws of [Your Country/Region].</p>

                <h3>10. Contact Information</h3>
                <p>If you have any questions regarding these terms and conditions, please contact us at:</p>
                 <p>Email: fusionspherellp@gmail.com</p>
                 <p>Phone: +9834429482</p>
            </div>
          )}

          {selectedTopic === "refund" && (
            <div>
              <h3>Refund Policy</h3>
              <p>At fusionsphere, we are committed to ensuring our customers are fully satisfied with their purchases. If for any reason you're not happy with your purchase, we offer a clear and simple refund policy.
              </p>

              <h3>Eligibility for Refund</h3>
              <p>To be eligible for a refund, the following conditions must be met:</p>
              <ul>
                <li>The item or service must be returned within 24 hrs from the date of purchase.</li>
                <li>The product should be in its original condition, unused, and in the original packaging.</li>
                <li>A proof of purchase, such as a receipt or order confirmation, must be provided.
                </li>
              </ul>

              <h3>Refund Process</h3>
              <p>If you meet the eligibility criteria, you can follow these steps to process your refund:</p>
              <ul>
                <li>Contact us via email at support@fusionspherellp.com to start the refund process.</li>
                <li>Ship the product back to us using a trackable shipping service at your cost, unless the product is defective or incorrect.</li>
                <li>Once we receive the returned item, we will process the refund to your original payment method within 7-10 business days.
                </li>
              </ul>

              <h3>Non-refundable Items</h3>
              <p>Unfortunately, the following items are not eligible for a refund:</p>
              <ul>
                <li>Gift cards</li>
                <li>Downloadable software or digital products</li>
                <li>Custom or personalized items
                </li>
              </ul>

              <h3>Need Assistance?</h3>
              <p>If you have any questions regarding our refund policy or need assistance, feel free to contact us:</p>
              <p>Email: support@fusionspherellp.com</p>
              <p>Phone: +9834429482</p>

              <button className="py-2 px-3 border-white bg-black text-white">Contact Us</button>

            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Privacy;
